import { styled } from '@sds-system/system';
import type { CSSObject } from '@sds-system/types';
import { getAllStyledProps, processNestedCSS } from '@sds-system/utils';
import type {
  CheckboxSizeKey,
  StyledCheckboxInputProps,
  StyledCheckboxRootProps,
} from './Checkbox.types';

const checkboxSizeStyle: Record<CheckboxSizeKey, CSSObject> = {
  '2XS': {
    backgroundSize: '10px',
  },
  XS: {
    backgroundSize: '12px',
  },
};

export const StyledCheckBoxRoot = styled('label', {
  componentName: 'Checkbox',
  slot: 'root',
})<StyledCheckboxRootProps>(({ theme }) => {
  return {
    width: 'max-content',
    position: 'relative',

    display: 'flex',
    alignItems: 'center',
    gap: theme.space[8],

    cursor: 'pointer',
  };
}, getAllStyledProps);

export const StyledCheckInput = styled('input', {
  componentName: 'Checkbox',
  slot: 'input',
})<StyledCheckboxInputProps>(({ checkboxSize = 'XS', theme }) => {
  return {
    appearance: 'none',
    margin: 0,

    width: theme.size[checkboxSize],
    height: theme.size[checkboxSize],
    minWidth: theme.size[checkboxSize],
    minHeight: theme.size[checkboxSize],

    border: `1px solid ${theme.palette.border.secondary}`,
    backgroundColor: theme.palette.bg.primary,
    borderRadius: 4,

    cursor: 'pointer',

    ':focus': {
      outline: 'none',
    },

    ':disabled': {
      cursor: 'not-allowed',
      ...processNestedCSS(
        {
          backgroundColor: theme.palette.bg.disabledLight,
          borderColor: theme.palette.border.disabled,
        },
        theme,
      ),

      ':checked': {
        ...processNestedCSS(
          {
            backgroundColor: theme.palette.bg.disabledDark,
          },
          theme,
        ),
      },
    },

    ':checked': {
      ...processNestedCSS(
        {
          ...checkboxSizeStyle[checkboxSize],
          border: 'none',
          backgroundColor: theme.palette.bg.interactive.primary,
        },
        theme,
      ),
    },
  };
}, getAllStyledProps);
